export default "__VITE_ASSET__DpZsifZG__"